import { athandAudioEffects } from './athand-audio-effects';
import { heroesAudioEffects } from './heroes-audio-effects';
import { champsAudioEffects } from './champs-audio-effects';
import { globetrottersAudioEffects } from './globetrotters-audio-effects';
import { hubAudioEffects } from './hub-audio-effects';
import { investigatorsAudioEffects } from './investigators-audio-effects';
import { superstarsAudioEffects } from './superstars-audio-effects';

export const generalAudioEffects: Map<string, string> = new Map<string, string>([

  ['accordion_close', 'fx/accordion_close.mp3'],
  ['accordion_enter', 'fx/accordion_enter.mp3'],
  ['accordion_open', 'fx/accordion_open.mp3'],

  ['action_enter', 'fx/action_enter.mp3'],
  ['action_random_click', 'fx/action_random_click.mp3'],
  ['action_redo_click', 'fx/action_redo_click.mp3'],
  ['action_undo_click', 'fx/action_undo_click.mp3'],

  ['adventure_chapter_click', 'fx/adventure_chapter_click.mp3'],
  ['adventure_chapter_completed', 'fx/adventure_chapter_completed.mp3'],
  ['adventure_chapter_start', 'fx/adventure_chapter_start.mp3'],
  ['adventure_character_moving', 'fx/adventure_character_moving.mp3'],
  ['adventure_final_trophy', 'fx/adventure_final_trophy.mp3'],
  ['adventure_level_click', 'fx/adventure_level_click.mp3'],
  ['adventure_level_lost', 'fx/adventure_level_lost.mp3'],
  ['adventure_level_won', 'fx/adventure_level_won.mp3'],
  ['adventure_show_vs', 'fx/adventure_show_vs.mp3'],

  ['answer_click', 'fx/answer_click.mp3'],
  ['answer_correct', 'fx/correct.mp3'],
  ['answer_enter', 'fx/answer_enter.mp3'],
  ['answer_incorrect', 'fx/incorrect.mp3'],
  ['answer_order_drop', 'fx/answer_order_drop.mp3'],
  ['answer_order_flip_in', 'fx/answer_order_flip_in.mp3'],
  ['answer_order_flip_out', 'fx/answer_order_flip_out.mp3'],
  ['answer_order_grab', 'fx/answer_order_grab.mp3'],
  ['answer_pass', 'fx/answer_pass.mp3'],
  ['answer_shuffle_click', 'fx/answer_shuffle_click.mp3'],

  ['assistant_show', 'fx/assistant_show.mp3'],
  ['assistant_hide', 'fx/assistant_hide.mp3'],

  ['battle_score_reveal', 'fx/battle_score_reveal.mp3'],
  ['battle_score_unknown', 'fx/battle_score_unknown.mp3'],
  ['battle_show_vs', 'fx/battle_show_vs.mp3'],
  ['battle_status_defeat', 'fx/battle_status_defeat.mp3'],
  ['battle_status_draw', 'fx/battle_status_draw.mp3'],
  ['battle_status_victory', 'fx/battle_status_victory.mp3'],
  ['battle_status_waiting', 'fx/battle_status_waiting.mp3'],
  ['battleitem_click', 'fx/battleitem_click.mp3'],
  ['battleitem_enter', 'fx/battleitem_enter.mp3'],
  ['battleslot_click', 'fx/battleslot_click.mp3'],
  ['battleslot_empty_click', 'fx/battleslot_empty_click.mp3'],
  ['battleslot_empty_enter', 'fx/battleslot_empty_enter.mp3'],
  ['battleslot_enter', 'fx/battleslot_enter.mp3'],

  ['btn_back_click', 'fx/click.mp3'],
  ['btn_back_enter', 'fx/enter.mp3'],
  ['btn_cancel_click', 'fx/click.mp3'],
  ['btn_cancel_enter', 'fx/enter.mp3'],
  ['btn_close_click', 'fx/enter.mp3'],
  ['btn_close_enter', 'fx/enter.mp3'],
  ['btn_controls_click', 'fx/click.mp3'],
  ['btn_controls_enter', 'fx/enter.mp3'],
  ['btn_default_click', 'fx/click.mp3'],
  ['btn_default_enter', 'fx/enter.mp3'],
  ['btn_delete_click', 'fx/click.mp3'],
  ['btn_delete_enter', 'fx/enter.mp3'],
  ['btn_page_down', 'fx/btn_page_down.mp3'],
  ['btn_page_up', 'fx/btn_page_up.mp3'],
  ['btn_save_click', 'fx/click.mp3'],
  ['btn_save_enter', 'fx/enter.mp3'],
  ['btn_show_password_click', 'fx/click.mp3'],
  ['btn_show_password_enter', 'fx/enter.mp3'],
  ['btn_start_click', 'fx/btn_start_click.mp3'],
  ['btn_text_click', 'fx/click.mp3'],
  ['btn_text_enter', 'fx/enter.mp3'],

  ['countdown_beep', 'fx/countdown_beep.mp3'],
  ['countdown_go', 'fx/countdown_go.mp3'],

  ['date_change', 'fx/date_change.mp3'],
  ['date_click', 'fx/date_click.mp3'],
  ['date_enter', 'fx/date_enter.mp3'],

  ['dilemma_progression_click', 'fx/dilemma_progression_click.mp3'],
  ['dilemma_progression_enter', 'fx/dilemma_progression_enter.mp3'],
  ['dilemma_reel_loop', 'fx/dilemma_reel_loop.mp3'],
  ['dilemma_reel_selected', 'fx/dilemma_reel_selected.mp3'],
  ['dilemma_reel_stop', 'fx/dilemma_reel_stop.mp3'],
  ['dilemma_reveal', 'fx/dilemma_reveal.mp3'],
  ['dilemma_stop_click', 'fx/dilemma_stop_click.mp3'],
  ['dilemma_stop_enter', 'fx/dilemma_stop_enter.mp3'],

  ['element_click', 'fx/element_click.mp3'],
  ['element_enter', 'fx/element_enter.mp3'],
  ['element_locked_click', 'fx/element_locked_click.mp3'],

  ['error', 'fx/error.mp3'],
  ['error_2', 'fx/error_2.mp3'],

  ['exam_failed', 'fx/exam_failed.mp3'],
  ['exam_level_1_click', 'fx/exam_level_1_click.mp3'],
  ['exam_level_2_click', 'fx/exam_level_2_click.mp3'],
  ['exam_level_3_click', 'fx/exam_level_3_click.mp3'],
  ['exam_level_deselect', 'fx/exam_level_deselect.mp3'],
  ['exam_passed', 'fx/exam_passed.mp3'],

  ['gender_toggle_click', 'fx/gender_toggle_click.mp3'],
  ['gender_toggle_enter', 'fx/gender_toggle_enter.mp3'],

  ['image_zoom_enter', 'fx/image_zoom_enter.mp3'],
  ['image_zoom_in', 'fx/image_zoom_in.mp3'],
  ['image_zoom_out', 'fx/image_zoom_out.mp3'],

  ['moodtracker_achievement', 'fx/moodtracker_achievement.mp3'],
  ['moodtracker_hide', 'fx/moodtracker_hide.mp3'],
  ['moodtracker_show', 'fx/moodtracker_show.mp3'],

  ['pencil_scratch', 'fx/pencil_scratch.mp3'],

  ['pulldown_click', 'fx/pulldown_click.mp3'],
  ['pulldown_enter', 'fx/pulldown_enter.mp3'],

  ['select_click', 'fx/select_click.mp3'],
  ['select_enter', 'fx/select_enter.mp3'],
  ['slider_down', 'fx/slider_down.mp3'],
  ['slider_enter', 'fx/slider_enter.mp3'],
  ['slider_move', 'fx/slider_move.mp3'],
  ['slider_up', 'fx/slider_up.mp3'],

  ['tab_click', 'fx/tab_click.mp3'],
  ['tab_enter', 'fx/tab_enter.mp3'],

  ['toggle_enter', 'fx/toggle_enter.mp3'],
  ['toggle_off', 'fx/toggle_off.mp3'],
  ['toggle_on', 'fx/toggle_on.mp3'],
  ['tooltip_enter', 'fx/tooltip_enter.mp3'],

  ['topmenu_click', 'fx/topmenu_click.mp3'],
  ['topmenu_enter', 'fx/topmenu_enter.mp3'],
  ['topmenu_sub_click', 'fx/topmenu_sub_click.mp3'],
  ['topmenu_sub_enter', 'fx/topmenu_sub_enter.mp3'],

  ['value_ticking', 'fx/value_ticking.mp3'],
  ['value_reached', 'fx/value_reached.mp3'],

  ['widget_enter', 'fx/widget_enter.mp3'],
  ['widget_click', 'fx/widget_click.mp3'],

  ['worldarea_click', 'fx/worldarea_click.mp3'],
  ['worldarea_enter', 'fx/worldarea_enter.mp3'],
]);

// Definition for theme-specific audio files
export const themeAudioEffects = {
  athand: athandAudioEffects,
  heroes: heroesAudioEffects,
  champs: champsAudioEffects,
  globetrotters: globetrottersAudioEffects,
  investigators: investigatorsAudioEffects,
  superstars: superstarsAudioEffects,
  hub: hubAudioEffects,
};
